<template>
  <div class="container-fluid">
    <div class="row signup-page
        two_step_reg">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <img src="static/images/logo_green.png" alt=""><br/>
          <span class="fb_span">{{ getTranslations.register2_subscribe_service_description }}</span><hr>
          <span class="fb_span">{{ getTranslations.register2_subscribe_price_point }}</span><hr><br/>
          <button @click.prevent="toNextStep()"
                  class="btn btn--medium btn--main">{{ getTranslations.register2_subscribe_subscribe }}
          </button><br/>
          <div>
            <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
               target="_blank"
               style="cursor: pointer"
               class="float-left">{{ getTranslations.register2_subscribe_t_and_c }}
            </a>
            <a @click.prevent="toFAQPage()"
               style="cursor: pointer"
               class="float-right">{{ getTranslations.register2_subscribe_faq }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';

export default {
  name: 'register2subscribe',
  mixins: [RegistrationFlowMixin],
  methods: {
    toNextStep() {
      this.getNextRegistrationStep()(true);
    },
    toFAQPage() {
      this.$router.push('/howItWorks');
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/Register2subscribe.vue